import { z } from 'zod';
import type {
  PostInboundReceiptInventoryRequest,
  PostInboundReceiptInventoryResponse,
} from './post-inbound-receipt-inventory.dto.js';
import {
  InboundReceiptDetailDtoSchema,
  InboundReceiptPostingUnitRegistrationInputSchema,
} from './inbound-receipts-shared.schema.js';

export const PostInboundReceiptInventoryRequestSchema: z.ZodType<PostInboundReceiptInventoryRequest> =
  z
    .object({
      companyId: z.uuid(),
      receiptId: z.uuid(),
      postingUnitRegistrations: z
        .array(InboundReceiptPostingUnitRegistrationInputSchema)
        .optional(),
    })
    .strict();

export const PostInboundReceiptInventoryResponseSchema: z.ZodType<PostInboundReceiptInventoryResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
    })
    .strict();
